__turbopack_context__.v({
  "layoutSpacing": "styles-module__b6JYgG__layoutSpacing",
});
